import {usePostEvents} from '../../hook/useEditPost'
import {formatShortenNumber} from '../../utils/format'
import {DEFAULT_DASHBOARD_QUERY_ARGS} from '../../data/defaults'
import {PercentageBar, virtualContentId, virtualEventType, virtualViewMode} from '@octavius-rocks/ui'
import {useDashboardQueryArgs} from '../../hook/useQueryArgs'
import {useStyles} from "./PostEventsWidget.styles";

export default ({postId})=>{
    const styles = useStyles();
    const list = usePostEvents(postId);
    const [_, setArgs] = useDashboardQueryArgs(DEFAULT_DASHBOARD_QUERY_ARGS) // ui state control of form

    const pageviews = list.reduce((prevValue, currentValue)=> prevValue + currentValue.hits, 0)

    return <ul>
        {list.map(({event_type, viewmode, hits})=>{
            const percent = Math.ceil((hits/pageviews)*100)
            const label = `${event_type}${viewmode? `/${viewmode}`:''}`
            const hitsInK = formatShortenNumber(hits);
            return <PercentageBar
                className={styles.item}
                key={event_type+viewmode}
                label={`${hitsInK}×${label}`}
                title={`${hitsInK} Events`}
                percentage={percent}
                onClick={()=>{
                    setArgs({
                        ...DEFAULT_DASHBOARD_QUERY_ARGS,
                        conditions:{
                            entries: [
                                {
                                    field: "event_type",
                                    compare: "=",
                                    value: event_type,
                                },
                                {
                                    field: "content_id",
                                    compare: "=",
                                    value: postId,
                                },
                                {
                                    field: "viewmode",
                                    compare: "=",
                                    value: viewmode ?? "",
                                },
                            ],
                            relation: "AND",
                        }
                    })
                    window.location.href = "/wp-admin/admin.php?page=octavius-rocks"
                }}
            />
        })}
    </ul>
}
